import React, { Component, RefObject } from 'react';
import MessageProvider from "../classes/MessageProvider";
import Dao from "../classes/Dao";
import { ServiceCollectionParam } from "./ServiceCollection";
import MessageBox from "./MessageBox";

const inputRef: RefObject<any> = React.createRef();

export default class ExamResultInputPage extends Component<ServiceCollectionParam, {}> {

    dao: Dao;

    messages = new MessageProvider(this.setState.bind(this));

    componentDidMount() {
        this.dao = this.props.services.dao;
    }

    render() {
        return (
            <div className="row">
                <div className="col-sm-12">

                    <MessageBox messages={this.messages.getMessages()}/>

                    <div className="input-group mt-3 mb-3">
                        <div>
                            <button
                                onClick={() => this.updateTestResults('test1', inputRef.current.value)}
                                className="btn btn-success">Kt 1 tulemused
                            </button>
                        </div>
                        &nbsp;
                        <div>
                            <button
                                onClick={() => this.updateTestResults('test2', inputRef.current.value)}
                                className="btn btn-success">Kt 2 tulemused
                            </button>
                        </div>
                        &nbsp;
                        <div>
                            <button
                                onClick={() => this.updateTestResults('exam', inputRef.current.value)}
                                className="btn btn-success">Eksami tulemused
                            </button>
                        </div>
                        &nbsp;
                        <div>
                            <button
                                onClick={() => this.validateRequirements(inputRef.current.value)}
                                className="btn btn-success">Kontrolli eeldust
                            </button>
                        </div>
                        &nbsp;
                        <button
                            onClick={() => this.confirmExamResults()}
                            className="p-1, btn btn-success">Kinnita eksami tulemused
                        </button>
                    </div>

                    <textarea rows={10}
                              ref={inputRef}
                              className="w-100"></textarea>

                    <button
                        onClick={() => this.applyDeclarationNames()}
                        className="btn btn-success">Names from Õis csv
                    </button>
                    &nbsp;
                    <button
                        onClick={() => this.updateDeclarationNames(inputRef.current.value)}
                        className="btn btn-success">Update names from Õis to ciName input
                    </button>
                    &nbsp;
                    <button
                        onClick={() => this.putNameToUsernameCsvToClipboard()}
                        className="btn btn-success">Nimi kasutajanimeks csv clipboard-i
                    </button>
                    &nbsp;
                    <button
                        onClick={() => this.cancelRegistrations(inputRef.current.value)}
                        className="btn btn-success">Tühista registreerimised
                    </button>

                </div>
            </div>
        );
    }

    async putNameToUsernameCsvToClipboard() {

        const data = await this.props.services.dao.getNameToUsernameCsv();

        await navigator.clipboard.writeText(data);
    }

    async updateDeclarationNamesCommon(apiFunc: () => Promise<string[]>) {
        this.messages.clearMessages();

        const unmatchedNames = await apiFunc();

        const unmatchedNamesString = unmatchedNames.join("\n");

        if (unmatchedNamesString) {
            this.messages.error(`Names not matched:\n${unmatchedNamesString}`);
        } else {
            this.messages.success(`All done!`);
        }
    }

    async updateDeclarationNames(dataAsCsv: string) {
        await this.updateDeclarationNamesCommon(
            () => this.dao.updateDeclarationNames(dataAsCsv)
        );
    }

    async applyDeclarationNames() {
        await this.updateDeclarationNamesCommon(
            () => this.dao.applyDeclarationNames()
        );
    }

    async updateTestResults(testId: string, dataAsJson: string) {
        this.messages.clearMessages();

        const updatedCount = await this.dao.updateTestResults(testId, dataAsJson);

        this.messages.success(`Updated: ${updatedCount} results`);
    }

    async validateRequirements(dataAsJson: string) {
        this.messages.clearMessages();

        const unqualifiedNames = await this.dao.validateRequirements(dataAsJson);

        const unqualifiedNamesString = unqualifiedNames.join("\n");

        if (unqualifiedNamesString) {
            this.messages.error(`Unqualified:\n${unqualifiedNamesString}`);
        } else {
            this.messages.success(`All qualified!`);
        }
    }

    async cancelRegistrations(boxContent: string) {
        this.messages.clearMessages();

        const usernames = boxContent.split(/\s/);

        const cancelledList = await this.dao.cancelRegistrations(usernames);

        if (cancelledList.length > 0) {
            this.messages.success(`Cancelled:\n${cancelledList.join("\n")}`);
        } else {
            this.messages.error(`Nothing cancelled!`);
        }
    }

    async confirmExamResults() {
        this.messages.clearMessages();

        const count = await this.dao.confirmTestResults();

        this.messages.success(`Confirmed: ${count} results`);
    }
}